import React from "react";
import { Link } from "react-router-dom";
import Visible from "../../../utils/Visible";
import useAsideStatus from "../../../hooks/useAsideStatus";
import LogoTemplate from "../Logo/Logo.template";
import Icon from "../../../components/icon/Icon";

const LogoAndAsideTogglePart = () => {
  const { asideStatus, setAsideStatus } = useAsideStatus();
  return (
    <>
      <Visible is={asideStatus}>
        <Link to="/" aria-label="Logo">
          <LogoTemplate className="h-12" />
        </Link>
      </Visible>
      <button
        type="button"
        aria-label="Toggle Aside Menu"
        onClick={() => setAsideStatus(!asideStatus)}
        className="flex h-12 w-12 items-center justify-center"
      >
        <Icon icon={asideStatus ? "HeroBars4BottomLeft" : "HeroBars3"} className="text-2xl w-[1.5rem]" />
      </button>
    </>
  );
};

export default LogoAndAsideTogglePart;
